
<div class="cp-frame" :class="star" :style="{height}">
  <slot></slot>
</div>
